import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { PaidInvoicesSuccess, OrderCanceled, OrderSubmitted, FlashSaleOrderSubmitted, LimitIncreaseApplicationSubmitted } from "@faire/retailer-visitor-shared/events";
import { useIsBrandPreview } from "@faire/retailer-visitor-shared/lib/getIsBrandPreview";
import { useRetailerStore } from "@faire/retailer-visitor-shared/stores/domain/RetailerStore";
import { useQuery as useRetailerCreditSummaryQuery } from "@faire/web-api--source/api/retailer/retailerToken/credit-summary/get-hooks";
import { useEffect } from "react";
export var useCreditSummary = function() {
    var retailerToken = useRetailerStore([
        "retailerToken"
    ]).retailerToken;
    var isBrandPreview = useIsBrandPreview();
    var _useRetailerCreditSummaryQuery = useRetailerCreditSummaryQuery(retailerToken !== null && retailerToken !== void 0 ? retailerToken : "", {
        enabled: !!retailerToken && !isBrandPreview
    }), refetch = _useRetailerCreditSummaryQuery.refetch, creditSummary = _useRetailerCreditSummaryQuery.data, retailerCreditSummaryResults = _object_without_properties(_useRetailerCreditSummaryQuery, [
        "refetch",
        "data"
    ]);
    useEffect(function() {
        PaidInvoicesSuccess.subscribe(function() {
            return refetch();
        });
        OrderCanceled.subscribe(function() {
            return refetch();
        });
        OrderSubmitted.subscribe(function() {
            return refetch();
        });
        FlashSaleOrderSubmitted.subscribe(function() {
            return refetch();
        });
        LimitIncreaseApplicationSubmitted.subscribe(function() {
            return refetch();
        });
    }, [
        refetch
    ]);
    return _object_spread_props(_object_spread({}, retailerCreditSummaryResults), {
        creditSummary: creditSummary,
        refetch: refetch
    });
};
